import Email from "../fundamentals/email/Email";
import Name  from "../fundamentals/name/Name";

class CorporationApplicant {
  constructor(
    private readonly _name: Name = new Name(),
    private readonly _email: Email = new Email()
  ) {
  }

  get name() {
    return this._name;
  }

  get email() {
    return this._email;
  }
}

export default CorporationApplicant;
